export default {"src":"/_next/static/media/ico4.de3b4f7b.svg","height":32,"width":70,"blurWidth":0,"blurHeight":0};